import { createFileRoute } from "@tanstack/react-router";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";

export const Route = createFileRoute("/_adminLayout/admin/parts/discounts/")({
  component: AdminDiscounts,
});